// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import QuestionFormController from "./question_form_controller"
application.register("question-form", QuestionFormController)

import QuestionReorderController from "./question_reorder_controller"
application.register("question-reorder", QuestionReorderController)

// External stimulus components
import RailsNestedForm from "@stimulus-components/rails-nested-form"
application.register("nested-form", RailsNestedForm)
